/**
 * Enum representing the different service types available in the application.
 * Each service type can have its own base URL configured in the environment.
 */
export enum ServiceType {
  AUTH = 'auth',
  PUBLIC = 'public',
  DEFAULT = 'default',
  AI_SERVICE = 'ai_service',
  SCORECARD = 'scorecard',
}
